import { render } from "./ClientDetailPage.vue?vue&type=template&id=c8c4dcf0"
import script from "./ClientDetailPage.vue?vue&type=script&lang=js"
export * from "./ClientDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__